// extracted by mini-css-extract-plugin
export default {"container":"fitment-size-group__container___1hagG"};